export default "__VITE_PUBLIC_ASSET__643025e5__"